
export default {
  name: 'CreateYourShiftsSvg',
};
